import { SET_BUY_ERROR } from './../const';

export default (buyError) => {
    return {
      type: SET_BUY_ERROR,
      buyError: buyError
    }
};
